import { createContext } from "react";
export default createContext({
    currentTheme: "standard",
    setCurrentTheme: function () { },
    addLayer: function () { return 0; },
    removeLayer: function () { }
});
